'use strict';

import register from './core';
import { getCurrentPageHeaderInfo } from '../functions/common'; // TODO: Use this function to the new accordion stuff to
import 'waypoints/lib/jquery.waypoints';
import 'waypoints/lib/shortcuts/inview';

register('page-navigation', function (element) {
  var $pageNavigation = $(element),
    $linkElements = $pageNavigation.find('.page-navigation__link'),
    $button = $pageNavigation.find('.page-navigation__button'),
    activeButtonClass = 'page-navigation__button--active',
    isBusyScrolling = false;

  new Waypoint.Sticky({
    stuckClass: 'page-navigation--stuck',
    element: element,
    handler: function () {
      var currentPageHeaderInfo = getCurrentPageHeaderInfo();
      if (!currentPageHeaderInfo.breadcrumbsVis) {
        var $pageNavStuckEl = $('.page-navigation--stuck');
        if ($pageNavStuckEl.length > 0)
          $pageNavStuckEl.css('top', '0'); //HACK: Manually set top to 0 if no breadcrumb present
      }
    }
  });

  $button.on('click', function () {
    $button.hasClass(activeButtonClass) ? toggleButton(false) : toggleButton(true);
  });

  function toggleButton(setActive) {
    setActive ? $button.addClass(activeButtonClass) : $button.removeClass(activeButtonClass);
    setActive ? $('#main').addClass('fade-content--active') : $('#main').removeClass('fade-content--active');
  }

  function setActiveNav($activeLink) {
    var linkActiveClass = 'page-navigation__link--active';
    $linkElements.removeClass(linkActiveClass);

    if (!$activeLink || $activeLink.length === 0)
      return;
    var text = $activeLink.first().addClass(linkActiveClass).text();
    $button.children('span').text(text);
  }

  $linkElements.on('click', function (event) {
    event.preventDefault();
    if (isBusyScrolling)
      return;

    var offset = getCurrentPageHeaderInfo().totalHeight;
    var target = $(this).attr('href').replace('#', '');
    var $target = $('[data-onpage-nav-target="' + target + '"]');

    if (!$target.length)
      return;

    var topPosition = $target.position().top;

    //because timelime page is acting weird (position returning 0, we take the parents next sibling to get more close to the target.)
    if ($target.hasClass('timeline-item') && topPosition === 0) {
     topPosition = $target.parent().position().top;
    }
    isBusyScrolling = true;
    setActiveNav($(this));
    toggleButton(false);

    $('html, body').animate({
      scrollTop: (topPosition + offset)
    }, 1000, function () {
        isBusyScrolling = false;
    });

  });

  $('[data-onpage-nav-target]').each(function (i, el) {
    new Waypoint.Inview({
      element: el,
      offset: 'bottom-in-view',
      entered: function (direction) {
        if (isBusyScrolling)
          return;

        var $activeLink = $('[href="#' + $(this.element).attr('data-onpage-nav-target') + '"]');
        setActiveNav($activeLink);
      },
      enabled: false //NOTE: Disable on init in order to avoid bugs where items are marked as selected even though they aren't in view port.
    });
  });

  //NOTE: Make sure that all waypoints are enabled
  setTimeout(function () {
    Waypoint.enableAll();
  }, 0);

  $(document).ready(function () {
    var hash = location.hash;
    if (hash && hash.substr(1)) {
      var $pageNavLink = $linkElements.filter(`[href="${hash}"]`);
      if ($pageNavLink.length)
        $pageNavLink.trigger('click');
    }
  });
});
